// @flow

import { selectorByPdbProperty } from '../config';
import { getEntries } from '../../../helpers';
import type { RangeFilters, GlobalState } from '../types';

const applyRangeFilter = (
  state: GlobalState,
  pdbId: string,
  rangeFilters?: RangeFilters,
): boolean => {
  if (!rangeFilters) {
    return true;
  }

  return getEntries(rangeFilters)
    .every(([label, { from, to }]) => {
      const value = selectorByPdbProperty[label](state, pdbId);
      if (value >= from && value <= to) {
        return true;
      }
      return false;
    });
};

export default applyRangeFilter;
